document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.querySelector('[data-gifting-confetti]');
  if (!overlay) return;

  const canvas = overlay.querySelector('canvas');
  if (!canvas) return;

  const ctx = canvas.getContext('2d');
  let w = window.innerWidth;
  let h = window.innerHeight;
  canvas.width = w;
  canvas.height = h;

  /* Golden palette only — warm, premium, festive */
  const colors = [
    '#ffd700', '#ffcc00', '#daa520', '#f5c542',
    '#e8b923', '#c9982e', '#fff1a8', '#ffe066',
  ];

  const particles = [];

  /* Firework burst origins — staggered across screen */
  const bursts = [
    { x: w * 0.25, y: h * 0.28, delay: 0 },
    { x: w * 0.55, y: h * 0.22, delay: 300 },
    { x: w * 0.78, y: h * 0.32, delay: 550 },
    { x: w * 0.4, y: h * 0.48, delay: 800 },
    { x: w * 0.65, y: h * 0.42, delay: 1050 },
  ];

  const createBurst = (cx, cy) => {
    const count = 40 + Math.floor(Math.random() * 15);

    for (let i = 0; i < count; i++) {
      const angle = (Math.PI * 2 * i) / count + (Math.random() - 0.5) * 0.4;
      const speed = 1.2 + Math.random() * 3.5;
      const color = colors[Math.floor(Math.random() * colors.length)];

      particles.push({
        x: cx,
        y: cy,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        size: 1.5 + Math.random() * 2,
        color: color,
        opacity: 1,
        life: 70 + Math.random() * 50,
        age: 0,
        gravity: 0.025,
        trail: [],
        twinkle: Math.random() > 0.6,
      });
    }

    /* white-gold flash at center */
    for (let i = 0; i < 8; i++) {
      const angle = (Math.PI * 2 * i) / 8;
      particles.push({
        x: cx,
        y: cy,
        vx: Math.cos(angle) * 5,
        vy: Math.sin(angle) * 5,
        size: 1.2,
        color: '#fff8dc',
        opacity: 1,
        life: 12,
        age: 0,
        gravity: 0,
        trail: [],
        twinkle: false,
      });
    }
  };

  let startTime = null;
  let allBurstsFired = false;

  const draw = (timestamp) => {
    if (!startTime) startTime = timestamp;
    const elapsed = timestamp - startTime;

    ctx.clearRect(0, 0, w, h);

    /* fire bursts at staggered delays */
    if (!allBurstsFired) {
      let done = true;
      for (const b of bursts) {
        if (!b.fired && elapsed >= b.delay) {
          createBurst(b.x, b.y);
          b.fired = true;
        }
        if (!b.fired) done = false;
      }
      allBurstsFired = done;
    }

    /* draw particles */
    for (let i = particles.length - 1; i >= 0; i--) {
      const p = particles[i];
      p.age++;

      p.trail.push({ x: p.x, y: p.y });
      if (p.trail.length > 5) p.trail.shift();

      p.vy += p.gravity;
      p.x += p.vx;
      p.y += p.vy;
      p.vx *= 0.985;

      const lifeRatio = p.age / p.life;
      p.opacity = Math.max(0, 1 - lifeRatio * lifeRatio);
      p.size *= 0.997;

      /* fading trail */
      for (let t = 0; t < p.trail.length; t++) {
        const tp = p.trail[t];
        const trailAlpha = (t / p.trail.length) * p.opacity * 0.2;
        ctx.globalAlpha = trailAlpha;
        ctx.beginPath();
        ctx.arc(tp.x, tp.y, p.size * 0.4, 0, Math.PI * 2);
        ctx.fillStyle = p.color;
        ctx.fill();
      }

      /* twinkle effect — subtle flicker */
      let drawOpacity = p.opacity;
      if (p.twinkle && p.age > 20) {
        drawOpacity *= 0.5 + 0.5 * Math.sin(p.age * 0.5);
      }

      /* main particle with golden glow */
      ctx.globalAlpha = drawOpacity;
      ctx.shadowColor = p.color;
      ctx.shadowBlur = 10;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
      ctx.fillStyle = p.color;
      ctx.fill();
      ctx.shadowBlur = 0;

      if (p.age >= p.life) {
        particles.splice(i, 1);
      }
    }

    ctx.globalAlpha = 1;

    if (allBurstsFired && particles.length === 0) {
      overlay.classList.add('gifting-confetti-overlay--fade');
      setTimeout(() => overlay.remove(), 700);
      return;
    }

    requestAnimationFrame(draw);
  };

  requestAnimationFrame(draw);
});
